import React from 'react';
import Link from 'next/link';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import BrandTicker from './BrandTicker';
const Questions = () => {
  return (
    <div className='questionsWrapper'>
      <Container className='questionsContainer' fluid>
        {/* <div className=' mt-4' style={{ marginBottom: '6rem' }}>
          {' '}
          <BrandTicker />
        </div> */}
        <Row className='theRow'>
          {' '}
          <Col className='theTop tw-flex tw-flex-col tw-gap-y-6'>
            <h2 className='theQuestion'>
              Have questions? <br />
              <span className='gradientTitle'>Get answers.</span>
            </h2>
            {/* <Link href='/faqs'>
              <p className='theReadMoreBtnLg '>Read More</p>
            </Link> */}
            <p className='tw-m-0 tw-text-[#1E1E1E99] tw-leading-4'>
              *24hrdoc is not a pharmacy. We do not carry or
              <br className='tw-hidden lg:tw-block' /> ship medicines. Online
              Doctor Prescriptions are <br className='tw-hidden lg:tw-block' />
              sent electronically to your pharmacy after an
              <br className='tw-hidden lg:tw-block' /> online medical
              consultation.
            </p>
          </Col>
          <Col className='theAccordion'>
            <Accordion flush>
              {FAQS.map((item) => (
                <Accordion.Item key={item.id} eventKey={item.id}>
                  <Accordion.Header>{item.Question}</Accordion.Header>

                  <Accordion.Body>{item.Answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
          {/* <Link href='/faqs'>
            <p className='readMore theReadMoreBtnSmall '>Read More</p>
          </Link> */}
        </Row>
        <ul className='tw-list-none tw-mt-16 tw-pl-0 tw-text-[11px] lg:tw-text-[13px] tw-text-doc_gray tw-opacity-70'>
          <li className=' tw-leading-5'>
            *24hrdoc is not a pharmacy. We do not carry or ship medicines.
            Online Doctor Prescriptions are sent electronically to your pharmacy
            after an online medical consultation.
          </li>
          <li className=' tw-leading-5'>
            *Similar to a doctor&apos;s office, our consultation fee does not
            include the cost of your medication.
          </li>
        </ul>
      </Container>
    </div>
  );
};

export default Questions;
const FAQS = [
  {
    id: 1,
    Question: 'How does the 24hrdoc work?',
    Answer:
      'It is a simple and fast process. You just select the medical condition you need to consult and that is available on our website, then, answer the questions about your health, and send the information to be reviewed by our providers. In some cases, it will be necessary to obtain more details about your medical condition and we will request information through a phone call or text message. Finally, we will send the prescription directly to the pharmacy for your convenience.',
  },
  {
    id: 2,
    Question: `What are Telehealth Services at 24hrdoc? `,
    Answer: `Telehealth is the use of digital information and communication technologies to access health care services remotely and manage your health. 24hrDoc services provide around-the-clock access to medical dr online and other medical professionals for consultation, diagnosis, treatment, and getting a doctor's prescription online.`,
  },
  {
    id: 3,
    Question: 'How do I use the 24hrdoc online service?',
    Answer:
      'To use the 24hrDoc online service, you must create an account. Once you have an account, you can access all of the resources available through your account. You can also ask questions using the Ask A Question function or chat with a doctor directly using our live support system.',
  },
  {
    id: 4,
    Question: 'Is there a fee for using the 24hrdoc online service?',
    Answer: `We do have a fee and it's on each of our conditions and it's paid before any visit. There is some nominal cost for each treatment that you will opt for. You can find more information about costs and fees by contacting us.`,
  },
  {
    id: 5,
    Question: 'What if my pharmacy does not have my medication?',
    Answer:
      'If this happens, you should contact us immediately. We will be happy to help you solve this problem by forwarding the prescription to other pharmacies so that you can receive your medication as soon as possible.',
  },
  {
    id: 6,
    Question: 'Do you accept insurance?',
    Answer:
      'No, insurance benefits do not apply to cover our services, and we do not file insurance claims. Your insurance may be used to pay for pharmacy medications, lab tests, x-ray imaging services and other tests.',
  },
];
